import editorMessages from 'scratch-l10n/locales/editor-msgs';

const customMessagesEn = {
    'gui.extension.visionclassifier.name': 'Data Classification',
    'gui.extension.visionclassifier.description': 'Train camera classes and control sprites with them.',
    'gui.extension.bodysensing.name': 'Body',
    'gui.extension.bodysensing.description': 'Use the camera to follow body parts.',
    'gui.extension.handsensing.name': 'Hand',
    'gui.extension.handsensing.description': 'Use the camera to follow hand parts.',
    'gui.extension.facesensing.name': 'Face',
    'gui.extension.facesensing.description': 'Use the camera to follow faces and expressions.',
    'visionClassifier.categoryName': 'Data',
    'visionClassifier.openTrainer': 'open data trainer',
    'visionClassifier.whenVisionLabel': 'when data is [LABEL]',
    'visionClassifier.isVisionLabel': 'is data [LABEL]?',
    'visionClassifier.currentVisionLabel': 'current data class',
    'visionClassifier.visionConfidence': 'confidence for [LABEL]',
    'visionClassifier.clearVisionTraining': 'clear data training',
    'visionClassifier.setCameraBackground': 'set camera background [VIDEO_STATE]',
    'visionClassifier.setCameraBackgroundTransparency': 'set camera background transparency to [TRANSPARENCY]',
    'bodySensing.categoryName': 'Body',
    'bodySensing.goToBodyPart': 'go to [BODY_PART]',
    'bodySensing.bodyDetected': 'can see body?',
    'bodySensing.bodyPartX': 'x for [BODY_PART]',
    'bodySensing.bodyPartY': 'y for [BODY_PART]',
    'bodySensing.setVideoState': 'set camera [VIDEO_STATE]',
    'bodySensing.setVideoTransparency': 'set camera transparency to [TRANSPARENCY]',
    'handSensing.categoryName': 'Hand',
    'handSensing.goToHandPart': 'go to [HAND_PART] [HAND_SUB_PART]',
    'handSensing.handDetected': 'can see hand?',
    'handSensing.setVideoState': 'set camera [VIDEO_STATE]',
    'handSensing.setVideoTransparency': 'set camera transparency to [TRANSPARENCY]',
    'faceSensing.categoryName': 'Face',
    'faceSensing.goToFacePoint': 'go to [FACE_POINT]',
    'faceSensing.whenExpressionDetected': 'when [EXPRESSION] is seen',
    'faceSensing.isExpressionDetected': 'is [EXPRESSION] seen?',
    'faceSensing.expressionAmount': 'amount of [EXPRESSION]',
    'faceSensing.whenEmotionDetected': 'when emotion [EMOTION] is seen',
    'faceSensing.isTopEmotion': 'is emotion [EMOTION]?',
    'faceSensing.emotionAmount': 'strength of emotion [EMOTION]',
    'faceSensing.setVideoState': 'set camera [VIDEO_STATE]',
    'faceSensing.setVideoTransparency': 'set camera transparency to [TRANSPARENCY]',
    'gui.guiTitle.datakoderen': 'Databyggeren',
    'gui.gui.defaultProjectTitle': 'My Project'
};

const customMessagesDa = {
    'gui.extension.visionclassifier.name': 'Dataklassifikation',
    'gui.extension.visionclassifier.description': 'Træn kameraklasser og styr sprites med dem.',
    'gui.extension.bodysensing.name': 'Krop',
    'gui.extension.bodysensing.description': 'Brug kameraet til at følge kropsdele.',
    'gui.extension.handsensing.name': 'Hånd',
    'gui.extension.handsensing.description': 'Brug kameraet til at følge hånddele.',
    'gui.extension.facesensing.name': 'Ansigt',
    'gui.extension.facesensing.description': 'Brug kameraet til at følge ansigt og udtryk.',
    'visionClassifier.categoryName': 'Data',
    'visionClassifier.openTrainer': 'åbn datatræner',
    'visionClassifier.whenVisionLabel': 'når data er [LABEL]',
    'visionClassifier.isVisionLabel': 'er data [LABEL]?',
    'visionClassifier.currentVisionLabel': 'aktuel dataklasse',
    'visionClassifier.visionConfidence': 'sikkerhed for [LABEL]',
    'visionClassifier.clearVisionTraining': 'ryd datatræning',
    'visionClassifier.setCameraBackground': 'sæt kamerabaggrund [VIDEO_STATE]',
    'visionClassifier.setCameraBackgroundTransparency': 'sæt kamerabaggrundens gennemsigtighed til [TRANSPARENCY]',
    'bodySensing.categoryName': 'Krop',
    'bodySensing.goToBodyPart': 'gå til [BODY_PART]',
    'bodySensing.bodyDetected': 'kan se krop?',
    'bodySensing.bodyPartX': 'x for [BODY_PART]',
    'bodySensing.bodyPartY': 'y for [BODY_PART]',
    'bodySensing.setVideoState': 'sæt kamera [VIDEO_STATE]',
    'bodySensing.setVideoTransparency': 'sæt kameragennemsigtighed til [TRANSPARENCY]',
    'handSensing.categoryName': 'Hånd',
    'handSensing.goToHandPart': 'gå til [HAND_PART] [HAND_SUB_PART]',
    'handSensing.handDetected': 'kan se hånd?',
    'handSensing.setVideoState': 'sæt kamera [VIDEO_STATE]',
    'handSensing.setVideoTransparency': 'sæt kameragennemsigtighed til [TRANSPARENCY]',
    'faceSensing.categoryName': 'Ansigt',
    'faceSensing.goToFacePoint': 'gå til [FACE_POINT]',
    'faceSensing.whenExpressionDetected': 'når [EXPRESSION] ses',
    'faceSensing.isExpressionDetected': 'ses [EXPRESSION]?',
    'faceSensing.expressionAmount': 'mængde af [EXPRESSION]',
    'faceSensing.whenEmotionDetected': 'når følelsen [EMOTION] ses',
    'faceSensing.isTopEmotion': 'er følelsen [EMOTION]?',
    'faceSensing.emotionAmount': 'styrke af følelsen [EMOTION]',
    'faceSensing.setVideoState': 'sæt kamera [VIDEO_STATE]',
    'faceSensing.setVideoTransparency': 'sæt kameragennemsigtighed til [TRANSPARENCY]',
    'gui.guiTitle.datakoderen': 'Databyggeren',
    'gui.gui.defaultProjectTitle': 'Mit projekt',
    'gui.gui.shouldDeleteSprite': 'Er du sikker på, at du vil slette denne sprite?',
    'gui.gui.shouldDeleteCostume': 'Er du sikker på, at du vil slette dette kostume?',
    'gui.gui.shouldDeleteSound': 'Er du sikker på, at du vil slette denne lyd?',
    'gui.gui.confirm': 'ja',
    'gui.gui.cancel': 'nej',
    'gui.gui.deleteAssetHeading': 'Bekræft sletning',
    'gui.menuBar.downloadToComputer': 'Gem på din computer uden model',
    'gui.sharedMessages.loadFromComputerTitle': 'Indlæs fra din computer',
    'gui.sharedMessages.saveToComputerWithModelTitle': 'Gem på din computer med model'
};

const mergedEditorMessages = Object.keys(editorMessages).reduce((acc, locale) => {
    acc[locale] = {
        ...editorMessages[locale],
        ...customMessagesEn
    };
    return acc;
}, {});

if (mergedEditorMessages.da) {
    mergedEditorMessages.da = {
        ...mergedEditorMessages.da,
        ...customMessagesDa
    };
}

export default mergedEditorMessages;
